import styled from 'styled-components';
import { floatingComponentStyles } from '../../../styles/shareableStyles';
import { theme } from '../../../styles/theme';

export const TOOLTIP_MIN_WIDTH = 160;
export const TOOLTIP_MAX_WIDTH = 300;
const PositionedContainer = styled.div`
  position: fixed;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
  border-radius: 8px;
`;

const TooltipContainer = styled.div`
  min-width: ${TOOLTIP_MIN_WIDTH}px;
  max-width: ${TOOLTIP_MAX_WIDTH}px;
  color: ${theme.colors.secondary800};
  ${floatingComponentStyles};
`;

const DataFrame = styled.div<{ $color: string }>`
  border-left: 4px solid ${({ $color }) => $color};
  display: flex;
  flex-direction: column;
  padding: 6px 16px;
`;

const HeaderRow = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 500;
`;

const DateLabel = styled.div`
  font-size: 10px;
  color: ${theme.colors.secondary600};
`;

const ValueLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  display: flex;
  gap: 4px;
`;

const ActionHint = styled.div`
  border-top: 1px solid ${theme.colors.border};
  background-color: ${theme.colors.blue500};
  display: flex;
  padding: 6px 8px;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

const MenuContainer = styled.div`
  border-top: 1px solid ${theme.colors.border};
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px 8px;
`;

const SubLabel = styled.div`
  font-size: 10px;
  font-weight: 400;
`;

export {
  PositionedContainer,
  TooltipContainer,
  DataFrame,
  DateLabel,
  ValueLabel,
  ActionHint,
  MenuContainer,
  HeaderRow,
  SubLabel,
};
